import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ApplicationClientCommonModule, CommonTranslationModule, TransportInfoPanelModule } from '@sdbn/common';
import { RegisterLeaveComponent } from './component/register-leave.component';

@NgModule({
  declarations: [RegisterLeaveComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    MatSelectModule,
    MatTooltipModule
  ]
})
export class RegisterLeaveModule { }
